import React from 'react';
import { Button } from '@/components/ui/button';
import { Scan } from 'lucide-react';

interface QRButtonProps {
  onClick: () => void;
  className?: string;
  variant?: 'default' | 'outline' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

/**
 * QR Scan Button Component
 * 
 * Simple button to open the QR scanner.
 * Can be placed anywhere in the navigation or pages.
 * 
 * Easy to remove: Just delete the button from navigation components.
 */
export function QRButton({
  onClick,
  className = '',
  variant = 'outline',
  size = 'default'
}: QRButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      size={size}
      className={className}
    >
      <Scan className="h-4 w-4 mr-2" />
      Scan QR
    </Button>
  );
}